export class CalendarRow {

  constructor(public days?: CalendarDay[]) { }

}

export class CalendarDay {
  constructor(
    public day: number,
    public event: boolean = false
  ) { }
}

export class NotificationRead {
  constructor(
    public readingDate: string,
    public notificationNumber: number
  ) { }
}
